import { actions } from '../../utils/constants';

export const asyncFetchTemplateTest = ({ testId }) => ({
    type: actions.ASYNC_FETCH_TEMPLATE_TESTS_TO_DUPLICATE,
    payload: { testId },
});



// WEBPACK FOOTER //
// ./src/components/duplicate-template-test/duplicate-template-test.actions.js